// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Messages":"cr_a bhl_a bhl_w","Messages__hasSeen":"cr_b bhl_p"};